import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { EventHubsDataset } from 'app/model/dataset/event-hubs.dataset';
import { EventHubsLinkedService } from 'shell-models-lib';

export const eventHubsDatasetMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(EventHubsDataset).name,
    displayName: stringResources.EventHubs_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(EventHubsLinkedService).name],
    isSource: false,
    isSink: false,
    datasetKind: 'unknown',
    icon: {
        className: 'svg-i-100x100-event_hubs'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    supportDataFlowSource: false,
    supportDataFlowSink: false
};
